import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { GET_REJECT_SLOT_OPTIONS_V2, GET_REJECT_SLOT_OPTIONS_V2_ERROR, GET_REJECT_SLOT_OPTIONS_V2_SUCCESS } from '../../../actions.js';

function* getRejectSlotOptionsV2({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/vendor/available-slots`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: {
        ...payload?.data,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_REJECT_SLOT_OPTIONS_V2_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_REJECT_SLOT_OPTIONS_V2_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_REJECT_SLOT_OPTIONS_V2_ERROR, payload: error });
  }
}

export function* watchgetRejectSlotOptionsV2() {
  yield takeEvery(GET_REJECT_SLOT_OPTIONS_V2, getRejectSlotOptionsV2);
}

function* getRejectSlotOptionsV2Saga() {
  yield all([fork(watchgetRejectSlotOptionsV2)]);
}

export default getRejectSlotOptionsV2Saga;
